import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
const createSelectors = (parentReducer) => {
    return new (class {
        selectUsers = (store) => {
            const reducer = store["MainReducer"];

            return reducer.users;
        };
        selectReportTypes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalDetailWidget_reducer"];
            return reducer.reportTypes;
        };
        getRequesting = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalDetailWidget_reducer"];
            return reducer.requesting;
        };
        selectToDate = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalBarChartWidget_reducer"];
            return reducer.toDate;
        };
        selectFromDate = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalBarChartWidget_reducer"];
            return reducer.fromDate;
        };
        selectReports = createSelector(
            [
                this.selectUsers,
                this.selectReportTypes,
                this.selectFromDate,
                this.selectToDate,
            ],
            (
                users = false,
                reportTypes = false,
                fromdate = false,
                todate = false
            ) => {
                if (users && reportTypes) {
                    let reportsPerUser = Object.keys(users).map((uid) => {
                        let fname =
                            _.get(users[uid], "profile.first_name") || "N/A";
                        let lname =
                            _.get(users[uid], "profile.last_name") || "N/A";
                        let reportsInfo = Object.keys(reportTypes).map(
                            (type) => {
                                let totalReportsPerType =
                                    _.get(users[uid], `reports.${type}`) ||
                                    false;
                                if (fromdate) {
                                    fromdate = moment(fromdate, "DD/MM/YYYY");
                                    if (todate === false) {
                                        todate = fromdate;
                                    } else
                                        todate = moment(todate, "DD/MM/YYYY");
                                    totalReportsPerType = filterByDate(
                                        totalReportsPerType,
                                        fromdate,
                                        todate
                                    );
                                }
                                let total = 0;
                                if (totalReportsPerType) {
                                    total = Object.keys(totalReportsPerType)
                                        .length;
                                } else total = 0;
                                return {
                                    reportType: type,
                                    total,
                                };
                            }
                        );
                        if (_.get(users[uid], "profile.deleted") === false)
                            return {
                                user_name: `${fname} ${lname}`,
                                reportsInfo,
                            };
                        else return false;
                    });

                    return _.compact(reportsPerUser);
                } else return false;
            }
        );
    })();
};
const filterByDate = (orderedDailyReports, dateFrom, dateTo) => {
    return _.filter(orderedDailyReports, (e) => {
        let date = e.timestamp.split(" ")[0];
        let current = moment(date, "DD-MM-YYYY");
        return current.isBetween(dateFrom, dateTo, null, "[]");
    });
};

export default createSelectors;
